<template>
  <div
    class="invite-list-wrapper"
    :class="{ smallHeight: dataList.length <= 3, bigHeight: dataList.length > 3, notHasCureent: rank.invitee < 10 }"
  >
    <el-table
      ref="inviteTable"
      :data="dataList"
      :border="false"
      stripe
      v-scrollLazy:el-table__body-wrapper="loadList"
      empty-text="快来分享链接给好友，赢取奖励吧"
    >
      <el-table-column prop="rank" label="当前排名" width="196">
        <template slot-scope="scope" v-if="rank.invitee < 10">
          <div v-if="scope.row.rank <= 21" :class="`hasBg hasBg${scope.row.rank}`"></div>
          <div v-else>{{ scope.row.rank }}</div>
        </template>
        <el-table-column v-if="rank.invitee >= 10" :label="rank.rank + ''" width="196">
          <template slot-scope="scope">
            <div v-if="scope.row.rank <= 21" :class="`hasBg hasBg${scope.row.rank}`"></div>
            <div v-else>{{ scope.row.rank }}</div>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column prop="inviterName" label="用户昵称" width="296">
        <template slot-scope="scope" v-if="rank.invitee < 10">
          {{ scope.row.inviterName }}
        </template>
        <el-table-column v-if="rank.invitee >= 10" :label="rank.inviterName" width="296">
          <template slot-scope="scope">
            {{ scope.row.inviterName }}
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column prop="inviterPhone" label="手机号" width="196">
        <template slot-scope="scope" v-if="rank.invitee < 10">
          {{ scope.row.inviterPhone }}
        </template>
        <el-table-column v-if="rank.invitee >= 10" :label="rank.inviterPhone" width="216">
          <template slot-scope="scope">
            {{ scope.row.inviterPhone }}
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column prop="invitee" label="邀请人数" width="162">
        <template slot-scope="scope" v-if="rank.invitee < 10">
          {{ scope.row.invitee }}
        </template>
        <el-table-column v-if="rank.invitee >= 10" :label="rank.invitee + ''" width="172">
          <template slot-scope="scope">
            {{ scope.row.invitee }}
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import scrollLazy from '../../directives/scrollLazy'
export default {
  name: 'IniviteList',
  props: {
    tableData: {
      type: Array,
      required: true
    },
    rank: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dataList: [],
      myRank: {
        invitee: 0,
        inviterId: null,
        inviterName: '张三',
        inviterPhone: '150****2586',
        rank: 0
      }
    }
  },
  directives: {
    scrollLazy
  },
  created() {
    this.dataList = JSON.parse(JSON.stringify(this.tableData))
    // console.log('this.dataList', this.tableData)
    this.myRank = JSON.parse(JSON.stringify(this.rank))
  },
  mounted() {},
  watch: {
    tableData: {
      handler(val) {
        this.dataList = JSON.parse(JSON.stringify(val))
      },
      deep: true
    },
    rank: {
      handler(val) {
        this.myRank = JSON.parse(JSON.stringify(val))
      },
      deep: true
    }
  },
  methods: {
    loadList() {
      this.$emit('getNextList')
    }
  }
}
</script>
<style lang="scss" scoped>
.invite-list-wrapper {
  width: 900px;
  margin: 0 auto;
  padding: 25px;
  &,
  * {
    box-sizing: border-box;
  }
  &.smallHeight {
    height: 274px;
    background: url('~@/assets/img/invite/smallBg.png') no-repeat center;
    background-size: cover;
    ::v-deep .el-table {
      height: 224px;
    }
  }
  &.bigHeight {
    height: 732px;
    background: url('~@/assets/img/invite/bigBg.png') no-repeat center;
    background-size: cover;
    ::v-deep .el-table {
      height: 680px;
    }

    &.notHasCureent {
      height: 692px;
      background: url('~@/assets/img/invite/notHasCureent.png') no-repeat center;
      background-size: cover;
      ::v-deep .el-table {
        height: 640px;
      }
    }
  }
  // &.isNeedScroll {
  //   ::v-deep .el-table {
  //     .el-table__body-wrapper {
  //       height: calc(100% - 1px);
  //       overflow-y: scroll;
  //     }
  //   }
  // }
  ::v-deep .el-table {
    // border: 1px solid rgba(255, 255, 255, 0.2);
    // min-height: 248px;
    width: 850px;
    background-color: transparent;
    &:before {
      background-color: transparent;
    }
    .el-table__body-wrapper {
      overflow-y: auto;
      overflow-x: hidden;
      // min-height: 208px;
      height: 600px;

      .el-table__empty-block {
        height: 184px !important;
        .el-table__empty-text {
          font-size: 18px;
          font-weight: 500;
          color: #ffffff;
        }
      }
    }
    th {
      height: 40px;
      background-color: transparent;
      border: none;
    }
    td {
      padding: 10px 0;
      border: none;
      background-color: rgba(41, 98, 255, 0.08);
    }
    .el-table__row--striped td {
      background-color: rgba(41, 98, 255, 0.15);
    }
    tr {
      background-color: transparent;
      &:nth-child(2n + 2) {
        th {
          background-color: rgba(41, 98, 255, 0.8);
        }
      }
    }
    .cell {
      height: 20px;
      line-height: 20px;
      font-size: 14px;
      color: #ffffff;
      font-weight: 500;
      padding: 0 48px;
      overflow-y: visible;
      div {
        line-height: 20px;
        font-size: 14px;
        color: #ffffff;
        font-weight: 500;
        position: relative;
        &.hasBg {
          position: absolute;
          left: 36px;
          top: 0;
          width: 40px;
          height: 40px;
          background: url('~@/assets/img/invite/ic_ranking_1.png') no-repeat center;
          background-size: 40px;
        }
        &.hasBg1 {
          background-image: url('~@/assets/img/invite/ic_ranking_1.png');
        }
        &.hasBg2 {
          background-image: url('~@/assets/img/invite/ic_ranking_2.png');
        }
        &.hasBg3 {
          background-image: url('~@/assets/img/invite/ic_ranking_3.png');
        }
        &.hasBg4 {
          background-image: url('~@/assets/img/invite/ic_ranking_4.png');
        }
        &.hasBg5 {
          background-image: url('~@/assets/img/invite/ic_ranking_5.png');
        }
        &.hasBg6 {
          background-image: url('~@/assets/img/invite/ic_ranking_6.png');
        }
        &.hasBg7 {
          background-image: url('~@/assets/img/invite/ic_ranking_7.png');
        }
        &.hasBg8 {
          background-image: url('~@/assets/img/invite/ic_ranking_8.png');
        }
        &.hasBg9 {
          background-image: url('~@/assets/img/invite/ic_ranking_9.png');
        }
        &.hasBg10 {
          background-image: url('~@/assets/img/invite/ic_ranking_10.png');
        }
        &.hasBg11 {
          background-image: url('~@/assets/img/invite/ic_ranking_11.png');
        }
        &.hasBg12 {
          background-image: url('~@/assets/img/invite/ic_ranking_12.png');
        }
        &.hasBg13 {
          background-image: url('~@/assets/img/invite/ic_ranking_13.png');
        }
        &.hasBg14 {
          background-image: url('~@/assets/img/invite/ic_ranking_14.png');
        }
        &.hasBg15 {
          background-image: url('~@/assets/img/invite/ic_ranking_15.png');
        }
        &.hasBg16 {
          background-image: url('~@/assets/img/invite/ic_ranking_16.png');
        }
        &.hasBg17 {
          background-image: url('~@/assets/img/invite/ic_ranking_17.png');
        }
        &.hasBg18 {
          background-image: url('~@/assets/img/invite/ic_ranking_18.png');
        }
        &.hasBg19 {
          background-image: url('~@/assets/img/invite/ic_ranking_19.png');
        }
        &.hasBg20 {
          background-image: url('~@/assets/img/invite/ic_ranking_20.png');
        }
        &.hasBg21 {
          background-image: url('~@/assets/img/invite/ic_ranking_21.png');
        }
      }
    }
  }
  ::v-deep .el-table--border::after,
  .el-table--group::after,
  .el-table::before {
    background-color: transparent !important;
  }

  // 滚动条设置
  ::v-deep .el-table {
    .el-table__body-wrapper {
      overflow-y: overlay;
      /* 自定义scrollbar */
      &::-webkit-scrollbar {
        width: 18px;
        background-color: transparent; /*//背景色*/
      }

      /*定义滚动条轨道 内阴影+圆角*/ /* 滚动槽 */
      &::-webkit-scrollbar-track {
        border-radius: 0 10px 10px 0;
        background-color: transparent; /*滚动条槽的颜色*/
      }

      /*定义滑块 内阴影+圆角*/ /* 滚动条滑块 */
      &::-webkit-scrollbar-thumb {
        height: 88px;
        border-radius: 8px;
        // background-color: rgba(20, 29, 51, 0.2);
        background-color: transparent;
        border: 6px solid transparent;
        box-shadow: 6px 0 0 #5e6066 inset;
      }
    }
  }
}
</style>
